
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.3 5.571H6.407c-.354 0-.693-.146-.944-.408a1.424 1.424 0 01-.39-.984V.116c0-.03-.012-.06-.033-.082A.109.109 0 004.96 0H2.403c-.472 0-.925.196-1.258.544a1.9 1.9 0 00-.521 1.313v9.286c0 .492.187.965.52 1.313.335.348.787.544 1.26.544H8.63c.472 0 .925-.196 1.259-.544a1.9 1.9 0 00.52-1.313V5.687c0-.03-.01-.06-.032-.082a.109.109 0 00-.078-.034zm-2.558 4.643h-4.45a.436.436 0 01-.314-.136.475.475 0 010-.656.436.436 0 01.315-.136h4.449c.118 0 .23.049.314.136a.475.475 0 010 .656.436.436 0 01-.314.136zm0-2.321h-4.45a.436.436 0 01-.314-.136.475.475 0 010-.657.436.436 0 01.315-.136h4.449c.118 0 .23.05.314.136a.475.475 0 010 .657.436.436 0 01-.314.136z"}}),_c('path',{attrs:{"d":"M10.056 4.544l-4-4.173a.053.053 0 00-.06-.012.056.056 0 00-.024.02.06.06 0 00-.01.033v3.767c0 .123.047.24.13.328a.436.436 0 00.315.136h3.61a.054.054 0 00.03-.01.06.06 0 00.008-.09z"}})])
          )
        }
      }
    